(() => {
  const filterButtons = document.querySelectorAll("[data-shop-filter]");
  const productCards = document.querySelectorAll("[data-shop-card]");
  const visibleCount = document.querySelector("[data-shop-visible-count]");

  const updateFilter = (filter) => {
    let count = 0;

    productCards.forEach((card) => {
      const matches = filter === "all" || card.dataset.productCategory === filter;
      card.hidden = !matches;
      if (matches) count += 1;
    });

    filterButtons.forEach((button) => {
      button.setAttribute("aria-pressed", String(button.dataset.shopFilter === filter));
    });

    if (visibleCount) {
      visibleCount.textContent = `${count} ${count === 1 ? "product" : "products"}`;
    }
  };

  filterButtons.forEach((button) => {
    button.addEventListener("click", () => {
      updateFilter(button.dataset.shopFilter || "all");
    });
  });

  const menuButton = document.querySelector("[data-menu-button]");
  const mobileMenu = document.querySelector("[data-mobile-menu]");

  if (menuButton && mobileMenu) {
    mobileMenu.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", () => {
        mobileMenu.classList.add("hidden");
        menuButton.setAttribute("aria-expanded", "false");
      });
    });
  }
})();
